import { useCallback } from 'preact/hooks';
var debounce = function (func, timeout) {
    if (timeout === void 0) { timeout = 1000; }
    var timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
            func();
        }, timeout);
    };
};
export var useDebounce = function (callback, timeout) {
    if (timeout === void 0) { timeout = 1000; }
    var func = useCallback(debounce(callback, timeout), []);
    return func;
};
